import './assets/main.css'
import { createApp } from 'vue'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import App from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import { createSentryPiniaPlugin } from '@sentry/vue'

const app = createApp(App)
const pinia = createPinia()
pinia.use(createSentryPiniaPlugin(Sentry))

Sentry.init({
  app,
  dsn: 'https://ef73a5b2dfc755ee1f36527698de6bf5@o4506550739992576.ingest.us.sentry.io/4507694787919872',
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration()
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})

app.use(createPinia())
app.use(router)
app.use(autoAnimatePlugin)
app.mount('#app')
